// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root___7uRu","left":"StickyBox_left__3m6RJ","right":"StickyBox_right__1LuR1"};